import {DataTableColumn} from "mantine-datatable";
import {MeterAssignmentRow} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp, TIMESTAMP_PLACEHOLDER} from "../../../utils/TableTimestamps.tsx";

// Every column is sortable (§3a). The `accessor` is what sorts: Customer sorts on
// `customerLabel`, the label the cell shows (resolved in useMeterAssignments), not on the
// customerId UUID behind it. Free Tier sorts numerically and timestamps as ISO-8601.
// Empty values render the shared placeholder (§13).
export const useMeterAssignmentsTableColumns = () => {

    const columns: DataTableColumn<MeterAssignmentRow>[] = [
        {
            accessor: 'customerLabel',
            title: I18n.get('Customer'),
            width: '1fr',
            sortable: true,
        },
        {
            accessor: 'meterId',
            title: I18n.get('Meter'),
            width: '1fr',
            sortable: true,
        },
        {
            accessor: 'channel',
            title: I18n.get('Channel'),
            width: '1fr',
            sortable: true,
        },
        {
            accessor: 'freeTierQuantity',
            title: I18n.get('Free Tier'),
            width: '1fr',
            sortable: true,
            render: (item: MeterAssignmentRow) => item.freeTierQuantity ?? TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            sortable: true,
            render: (item: MeterAssignmentRow) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'effectiveFrom',
            title: I18n.get('Effective From'),
            width: '1fr',
            sortable: true,
            render: (item: MeterAssignmentRow) => formatTimestamp(item.effectiveFrom),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            sortable: true,
            render: (item: MeterAssignmentRow) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    }
}
